export function rarityClass(rarity) {
  switch (rarity) {
    case 'C': return 'false-white-bg light-grey-border'
    case 'UC': return 'light-grey-bg grey-border'
    case 'R': return 'rare-bg'
    case 'SR': return 'super-rare-bg'
    case 'SEC': return 'sec-bg'
    case 'PR': return 'promo-bg'
    case 'L': return 'leader-bg'
    default: return ''
  }
}

export function cardProductRarityClass(rarity) {
  switch (rarity) {
    case 'C': return 'false-white-bg grey-text'
    case 'UC': return 'light-grey-bg dark-grey-text'
    case 'R': return 'rare-bg'
    case 'SR': return 'super-rare-bg'
    case 'SEC': return 'sec-bg'
    case 'PR': return 'promo-bg'
    case 'L': return 'leader-bg'
    default: return ''
  }
}
